export const WILD = "WILD";
export const SCATTER = "SCATTER";

const SYMBOL_DEFS = [
    ["L1", 10],
    ["L2", 10],
    ["L3", 10],
    ["L4", 10],
    ["H1", 3],
    ["H2", 4],
    ["H3", 5],
    ["H4", 6],
    [WILD, 2],
    [SCATTER, 2],
];

export const symbols = SYMBOL_DEFS.map(([name, weight], id) => ({
    name,
    id,
    weight,
    children: [{ type: name, label: "body", anchor: [0.5, 0.5] }],
}));

export const paytable = {
    L1: [0.75, 1.00, 1.25],
    L2: [0.75, 1.00, 1.25],
    L3: [0.75, 1.00, 1.25],
    L4: [0.75, 1.00, 1.25],
    H1: [6.00, 8.00, 10.00],
    H2: [3.60, 4.80, 6.00],
    H3: [2.40, 3.20, 4.00],
    H4: [1.20, 1.60, 2.00],
    [WILD]: [6.00, 8.00, 10.00],
    [SCATTER]: [6.00, 8.00, 10.00],
};
